import { render, staticRenderFns } from "./PaymentByDeliveryRelationSettings.vue?vue&type=template&id=06655acf&scoped=true&"
import script from "./PaymentByDeliveryRelationSettings.vue?vue&type=script&lang=js&"
export * from "./PaymentByDeliveryRelationSettings.vue?vue&type=script&lang=js&"
import style0 from "./PaymentByDeliveryRelationSettings.vue?vue&type=style&index=0&id=06655acf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06655acf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
